import type { ReactNode } from 'react';

interface BetaAdminCardProps {
  title: string;
  description?: string;
  icon?: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function BetaAdminCard({
  title,
  description,
  icon,
  children,
  footer,
  className = '',
}: BetaAdminCardProps) {
  return (
    <section className={`beta-admin-card ${className}`.trim()}>
      <header className="beta-admin-card-head">
        <div className="beta-admin-card-title-row">
          {icon && <span className="beta-admin-card-icon" aria-hidden>{icon}</span>}
          <h3 className="beta-admin-card-title">{title}</h3>
        </div>
        {description && <p className="beta-admin-card-desc">{description}</p>}
      </header>
      <div className="beta-admin-card-body">{children}</div>
      {footer && <footer className="beta-admin-card-foot">{footer}</footer>}
    </section>
  );
}

interface BetaAdminFieldProps {
  label: string;
  hint?: string;
  htmlFor?: string;
  full?: boolean;
  children: ReactNode;
}

export function BetaAdminField({ label, hint, htmlFor, full, children }: BetaAdminFieldProps) {
  return (
    <div className={`beta-admin-field${full ? ' beta-admin-field--full' : ''}`}>
      <label className="beta-admin-field-label" htmlFor={htmlFor}>{label}</label>
      {hint && <p className="beta-admin-field-hint">{hint}</p>}
      {children}
    </div>
  );
}

interface BetaAdminActionsProps {
  children: ReactNode;
  align?: 'start' | 'end';
}

export function BetaAdminActions({ children, align = 'start' }: BetaAdminActionsProps) {
  return (
    <div className={`beta-admin-actions beta-admin-actions--${align}`}>
      {children}
    </div>
  );
}

interface BetaAdminModeOptionProps {
  label: string;
  description: string;
  active: boolean;
  current: boolean;
  disabled?: boolean;
  onSelect: () => void;
}

export function BetaAdminModeOption({
  label,
  description,
  active,
  current,
  disabled,
  onSelect,
}: BetaAdminModeOptionProps) {
  return (
    <button
      type="button"
      className={[
        'beta-admin-mode-option',
        active ? 'beta-admin-mode-option--active' : '',
        current ? 'beta-admin-mode-option--current' : '',
      ].filter(Boolean).join(' ')}
      onClick={onSelect}
      disabled={disabled}
    >
      <span className="beta-admin-mode-option-label">{label}</span>
      <span className="beta-admin-mode-option-desc">{description}</span>
      {current && <span className="beta-admin-mode-option-badge">Actif</span>}
    </button>
  );
}

export function betaAdminInputProps(disabled?: boolean) {
  return {
    className: 'beta-admin-input',
    disabled,
  };
}

export function betaAdminTextareaProps(disabled?: boolean, rows?: number) {
  return {
    className: 'beta-admin-textarea',
    disabled,
    rows,
  };
}
